/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Canvas_Versions_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Restore version {version}?" |
*
* @param {Canvas_Versions_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_restore_title = /** @type {((inputs: Canvas_Versions_Restore_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_Restore_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Version ${i?.version} wiederherstellen?`)
	return /** @type {LocalizedString} */ (`Restore version ${i?.version}?`)
});